import { useContext } from "react";
import { IPermissionsControlledWrapper } from "./types";
import { checkPermissions } from "./helper";
import { AppContext } from "src/context/AppContext";

const PermissionsControlledWrapper = (props: IPermissionsControlledWrapper) => {
  const { requiredPermission, children } = props;
  const {
    context: { user },
  } = useContext(AppContext);
  return checkPermissions(user?.permissions, requiredPermission)
    ? children
    : null;
};

export default PermissionsControlledWrapper;
